import * as React from 'react';

import { cn } from '@talentmesh/ui/lib/utils';

export type TextareaProps = React.ComponentProps<'textarea'>;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => {
    return (
        <textarea
            ref={ref}
            data-slot="textarea"
            className={cn(
                'border-input bg-card ring-offset-background placeholder:text-muted-foreground flex min-h-16 w-full resize-y rounded-xl border px-3.5 py-2 text-sm',
                'focus-visible:border-primary focus-visible:ring-primary transition-colors duration-200 outline-none focus-visible:ring-1 focus-visible:ring-offset-0',
                'aria-invalid:border-destructive dark:aria-invalid:border-destructive/50',
                'aria-invalid:focus-visible:border-destructive aria-invalid:focus-visible:ring-destructive dark:aria-invalid:focus-visible:border-destructive/50 dark:aria-invalid:focus-visible:ring-destructive/50',
                'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
                className,
            )}
            {...props}
        />
    );
});
Textarea.displayName = 'Textarea';

export { Textarea };
